import React from 'react'
import { useState } from 'react'
import { Link } from 'react-router-dom'
import './postWrite.css'
import { Loading } from '../components'
import axios from 'axios'
import { useDispatch } from 'react-redux'
import { upload } from '../../redux/actions'

function Write({ postInputHandle, post }) {
  return (
    <div className="input-group mb-3">
      <textarea
        type={'text'}
        className="form-control poi"
        id="exampleFormControlTextarea1"
        rows="3"
        value={post}
        placeholder={`What's happening?`}
        onChange={postInputHandle}
      ></textarea>
    </div>
  )
}

function PostWrite() {
  const [post, setPost] = useState('')
  const [postLoading, setPostLoading] = useState(false)
  const dispatch = useDispatch()

  const avatar = JSON.parse(localStorage.getItem('_syt2022_')).avatar
  const userData = JSON.parse(localStorage.getItem('_syt2022_'))

  function postInputHandle(e) {
    setPost(e.target.value)
  }
  function postSubmit() {
    if (!post.trim()) return
    setPostLoading(true)
    axios
      .post(`${process.env.REACT_APP_API_URL}/posting`, {
        post: post,
        UID: userData.uid,
        uploderName: `${userData.fname} ${userData.lname}`,
        uploderAvatar: userData.avatar,
      })
      .then(() => {
        setPost('')
        setPostLoading(false)
        dispatch(upload())
      })
      .catch((error) => {
        setPostLoading(false)
      })
  }

  return (
    <div className="row bb mt-3">
      <div className="col-lg-2 col-2">
        <Link to={`/${userData.uid}`}>
          <img src={avatar} id="havatar" alt="PP" />
        </Link>
      </div>
      <div className="col-lg-10 col-9">
        <Write postInputHandle={(e) => postInputHandle(e)} post={post} />
        <button
          type="button"
          className="float-end post btn btn-md postbtn"
          onClick={() => {
            postSubmit()
          }}
        >
          {postLoading ? <Loading /> : 'Post'}
        </button>
      </div>
    </div>
  )
}

export default PostWrite
